// A copy do avatar da conversa (spec-009, D-009-5).
//
// Arquivo próprio, ao lado do componente, no molde de
// `boas-vindas-falada/roteiro.js` — e não `constants/TextChat.js`, que é
// disputado por várias frentes desta branch ao mesmo tempo.
//
// ★ Nenhuma frase aqui carrega dado de negócio. Quem diz número, nome de
// cliente e data é a RESPOSTA — que vai para a tela pelo caminho de sempre e é
// a fonte auditável; o avatar só fala a consolidação dela.
export const AVATAR_DA_CONVERSA = Object.freeze({
  // Nome acessível da região inteira.
  ARIA: 'Conversa falada com o avatar',
  ARIA_RETRATO: 'Avatar da AAWZ',
  // Os dois estados que o consultor precisa distinguir de relance: quem tem a
  // vez agora. "Ouvindo" seria mentira — o microfone só abre se ele ditar.
  FALANDO: 'Falando com você',
  AGUARDANDO: 'Sua vez: escreva ou use o microfone',
  ENCERRAR: 'Encerrar conversa falada',
})
